"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));































var _detailReportTable = _interopRequireDefault(require("./detailReportTable")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'DetailReprot', components: { DetailReportTable: _detailReportTable.default }, data: function data() {return { dataAnalysisList: [], isShow: false, addData: { downMonitorNum: '', downDataParser: '', isConvert: 'false', isSubjoin: 'false', upReadType: '' }, rules: {} };}, mounted: function mounted() {var self = this;self.handleGetData();}, watch: { 'addData.upReadSettings': { handler: function handler(val, oldval) {if (val !== oldval) {this.handleChangeSubjoin();}} } },


  methods: {
    handleGetData: function handleGetData() {
      this.dataAnalysisList.push({ name: '无需解析', value: 'empty_parser' });
      this.dataAnalysisList.push({ name: '正常数值解析', value: 'number_parser' });
      this.dataAnalysisList.push({ name: '高低位数值解析', value: 'reverse_number_parser' });
      this.dataAnalysisList.push({ name: '十六进制解析', value: 'hexstring_parser' });
      this.dataAnalysisList.push({ name: '时间解析', value: 'time_parser' });
      this.dataAnalysisList.push({ name: '位解析', value: 'bit_parser' });
      this.dataAnalysisList.push({ name: '字符串解析', value: 'string_parser' });
      this.dataAnalysisList.push({ name: '多个位解析', value: 'multi_bit_parser' });
      this.dataAnalysisList.push({ name: '一位小数解析', value: 'decimal_parser' });
    },
    handleGetReportData: function handleGetReportData(data) {
      var self = this;
      self.addData = data;
      if (self.$refs.reportTable) {
        self.$refs.reportTable.tableData = self.addData.upReadSettings;
      }
    },
    handleChangeSubjoin: function () {var _handleChangeSubjoin = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {var self;return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                self = this;
                if (self.addData.upReadType === '1') {
                  self.isShow = true;
                  if (!self.$refs.reportTable) {
                    setTimeout(function () {
                      console.log('upRead', self.addData.upReadSettings);
                      self.$refs.reportTable.handleGetData(self.addData.upReadSettings);
                    }, 200);
                  }
                } else {
                  self.isShow = false;
                }case 2:case "end":return _context.stop();}}}, _callee, this);}));function handleChangeSubjoin() {return _handleChangeSubjoin.apply(this, arguments);}return handleChangeSubjoin;}(),

    handleGetResult: function handleGetResult() {
      if (this.$refs.reportTable) {
        this.addData.upReadSettings = this.$refs.reportTable.tableData;
      }
      return this.addData;
    },
    handleChangeFunctionShow: function handleChangeFunctionShow() {
      this.$emit('handleChangeFunctionShow');
    },
    handleChangeConvert: function handleChangeConvert() {
    } } };exports.default = _default;